// Libraries
var React = require('react');

// Style
require('./RichText.scss');

class RichTextModule extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			closed: true,
		};

		this.isLoadMore = this.props.data.isLoadMore;
	}

	handleLoadMore = _ => {
		this.setState({closed: !this.state.closed})
	};

	createContent = _ => {
		return {__html: this.props.data.content};
	};

	render() {
		return (
			<div className={"RichText " + this.props.className}>
				<div  className={"RichText__text" + (this.state.closed && this.isLoadMore ? " RichText__text--short" : "")}>
					{this.props.className === "PlayerHero__playerBio" ? (
						<div className="rte"><p dangerouslySetInnerHTML={this.createContent()}></p></div>
					) : (
						<div className="rte" dangerouslySetInnerHTML={this.createContent()}></div>
					)}
				</div>
				{this.isLoadMore &&
					<div className="readmoreButton">
						<button className="RichText__toggle" onClick={this.handleLoadMore} type="button">Read {this.state.closed ? "More +" : "Less -"}</button>
					</div>
				}
			</div>
		);
	}
};

module.exports = RichTextModule;



// WEBPACK FOOTER //
// ./src/components/RichText/RichTextModule.js